import { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'

import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Input from '../../Form/Field/Input.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Date from "../../Form/Field/Date.jsx"
import UserTypehead from "../../Form/Field/UserTypehead.jsx"

import validate from './validate'
import { UncontrolledTooltip } from 'reactstrap'

import './OfferAnswerForm.scss'

export const name = 'OfferForm'

class OfferApplicationForm extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    return (
      <div id={name}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          {
            this.props.isAdmin &&
            <div className="row">
              <div className="col-12">
                <Field
                  label="Tapez un nom, prénom ou ID"
                  name="user"
                  type="text"
                  component={UserTypehead}
                />
              </div>
            </div>
          }
          <div className="row">
            <div className="col-md-6">
              <Field
                label="TJM indicatif (&euro;) :"
                name="tjm"
                type="number"
                component={Input} />
            </div>
            <div className="col-md-6">
              <Field
                label="Date de disponibilité :"
                name="availability_date"
                type="text"
                placeholder="jj/mm/aaaa"
                component={Date} />
            </div>
            <div className="col-md-12">
              <Field
                id="comment"
                label="Commentaire :"
                name="comment"
                component={Input}
                type="textarea"
              />
              <UncontrolledTooltip
                placement="top"
                target="comment"
                className="d-none d-md-block"
              >
                SVP justifiez l'adéquation de votre profil à la mission ; précisez rapidement l(es) experience(s) la plus proche du sujet.
                Vous pouvez aussi détailler votre disponibilité et mobilité ou simplement nous envoyer un message
              </UncontrolledTooltip>

              <span className="offer-application-info d-block d-md-none">
                SVP justifiez l'adéquation de votre profil à la mission ; précisez rapidement l(es) experience(s) la plus proche du sujet.
                Vous pouvez aussi détailler votre disponibilité et mobilité ou simplement nous envoyer un message
              </span>
            </div>
          </div>

          <input className="d-none" type="submit" />
          <FormGlobalErrors className="mt-0" errors={this.props.error} />
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit} />
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  validate,
})(OfferApplicationForm)
